export default __webpack_public_path__ + "static/membership-page-preview-section-bg-mob-9484fc13bd35f010000636b699fd7d14.jpg";